export const addCommentsConstant = {
    ADD_NEW_COMMENTS_SUCCESS: "ADD_NEW_COMMENTS_SUCCESS",
    ADD_NEW_COMMENTS_FAILURE: "ADD_NEW_COMMENTS_FAILURE"
}